export default "__VITE_ASSET__BS$L4xnO__"